import React, { useEffect, useState } from "react";
import ProgressCircle from "../../../ProgressCircle";

export default function AlertaAzul({
  titulo = "Éxito",
  descripcion = "Todo salio perfecto!!",
  tiempo = 0,
  mostarBotones = false,
  isBotonAceptar = true,
  isBotonCancelar = true,
  textoBotonAceptar = "Aceptar",
  textoBotonCancelar = "Cancelar",
  handleAceptar = () => {},
  handleCancelar = () => {},
  handleCerrar = () => {},
}) {
  // Estado para manejar el progreso del círculo
  const [progress, setProgress] = useState(100);
  const [isHovered, setIsHovered] = useState(false);

  // Efecto para manejar el temporizador y actualizar el progreso
  useEffect(() => {
    const intervalTime = 100; // Actualización cada 100ms
    const totalIntervals = (tiempo * 1000) / intervalTime; // Número total de intervalos
    const decrementPerInterval = 100 / totalIntervals; // Cantidad de decremento por intervalo

    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        const newProgress = Math.max(prevProgress - decrementPerInterval, 0);
        return newProgress;
      });
    }, intervalTime);

    return () => clearInterval(interval);
  }, [tiempo]);

  /**
   * Maneja el evento cuando el cursor entra en el botón de cierre.
   */
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  /**
   * Maneja el evento cuando el cursor sale del botón de cierre.
   */
  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  return (
    <div data-figma-id="5290:20224" class="warning-info-2">
      <div data-figma-id="5290:20187" class="frame-290022">
        <div data-figma-id="5290:20188" class="warning-advertencia-2-icono-3">
          <i class="fi fi-sr-info img-95"></i>
        </div>
        <div data-figma-id="5290:20190" class="warning-advertencia-2-info">
          <p
            data-figma-id="5290:20191"
            class="warning-advertencia-2-info-texto-1-2"
          >
            {titulo}
          </p>
          <p
            data-figma-id="5290:20192"
            class="warning-advertencia-2-info-texto-2-2"
          >
            {descripcion}
          </p>
        </div>
        <div data-figma-id="5290:20193" class="warning-x-2">
          <i class="fi fi-rr-cross-small img-96" onClick={handleCerrar}></i>
          {tiempo > 0 && <ProgressCircle progress={progress} />}
        </div>
      </div>
      {mostarBotones && (
        <div data-figma-id="5290:20195" class="frame-289841">
          {isBotonAceptar && (
            <div
              data-figma-id="5290:20220"
              class="div-block-5"
              onClick={handleAceptar}
            >
              <p data-figma-id="5290:20221" class="aceptar">
                {textoBotonAceptar}
              </p>
            </div>
          )}
          {isBotonCancelar && (
            <div
              data-figma-id="5290:20222"
              class="div-block-5"
              onClick={handleCancelar}
            >
              <p data-figma-id="5290:20223" class="cancelar-2">
                {textoBotonCancelar}
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
